import Http from './../../services/HTTP';

const MAKE_SAFE_CALL = "MAKE_SAFE_CALL";
function makeSafeCallWaiting() {
    return {
      type: MAKE_SAFE_CALL,
      make_safe_call_waiting: true,
      make_safe_call_response: {},
      make_safe_call_error: {},
    };
  }

  function makeSafeCallSuccess(response) {
    return {
      type: MAKE_SAFE_CALL,
      make_safe_call_waiting: false,
      make_safe_call_response: response,
      make_safe_call_error: {},
    };
  }
  
  function makeSafeCallError(error) {
    return {
      type: MAKE_SAFE_CALL,
      make_safe_call_waiting: false,
      make_safe_call_response: {},
      make_safe_call_error: error,
    };
  }

  function makeSafeCallEmpty() {
    return {
      type: MAKE_SAFE_CALL,
      make_safe_call_waiting: false,
      make_safe_call_response: {},
      make_safe_call_error: {},
    };
  }
  
  function makeSafeCall(data) {
    return (dispatch) => {
      dispatch(makeSafeCallWaiting());
      const post = Http.POST("v1/medical_delivery/safe-call",data);
      post
        .then((response) => {
          if (response !== undefined) dispatch(makeSafeCallSuccess(response));
        })
        .catch((error) => {
          dispatch(makeSafeCallError(error));
        });
    };
  }

  export {
      MAKE_SAFE_CALL,
      makeSafeCall,
      makeSafeCallEmpty
  }